exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".version{margin-right:1px}.catalog-card-body{-ms-flex:1 1 auto;flex:1 1 auto;padding:1.25rem 1.25rem 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2d7c134","scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/catalogs/Catalog.vue
// module id = 429
// module chunks = 1